import { absolutePath } from "../../../absolutePath";

interface UpdateSessionParams {
  paywallId: number;
  sessionId: number;
}

export const checkoutSession = {
  create: (): string => absolutePath("paywalls/checkout/sessions"),
  show: (params: {
    paywallId: number;
    sessionId?: number;
    stepId?: number;
    paymentIntentId?: string;
    invoiceId?: string;
    setupIntentId?: string;
  }): string => {
    const {
      paywallId,
      sessionId,
      stepId,
      paymentIntentId,
      invoiceId,
      setupIntentId,
    } = params;

    return absolutePath("paywalls/checkout/sessions/show", {
      paywall_id: paywallId,
      ...(sessionId && { session_id: sessionId }),
      ...(stepId && { step_id: stepId }),
      ...(paymentIntentId && { payment_intent_id: paymentIntentId }),
      ...(invoiceId && { invoice_id: invoiceId }),
      ...(setupIntentId && { setup_intent_id: setupIntentId }),
    });
  },
  update: ({ sessionId, paywallId }: UpdateSessionParams): string =>
    absolutePath(`paywalls/checkout/sessions/${sessionId}`, {
      paywall_id: paywallId,
    }),
};
